import { __decorate, __metadata, __param } from "tslib";
import { Inject, Injectable } from 'angular-ts-decorators';
var HashSeekerService = (function () {
    function HashSeekerService($location) {
        this.$location = $location;
        this.privateSection = '';
        this.privateItems = [];
        this.intialize();
    }
    HashSeekerService.prototype.clear = function () {
        this.privateSection = '';
        this.privateItems.length = 0;
        this.$location.path('');
    };
    HashSeekerService.prototype.items = function () {
        return this.privateItems;
    };
    HashSeekerService.prototype.section = function () {
        return this.privateSection;
    };
    HashSeekerService.prototype.intialize = function () {
        var path = this.$location.path();
        var paths = path.split('/').filter(function (urlPart) { return urlPart !== ''; });
        if (path === '') {
            this.$location.path('/');
        }
        this.privateSection = (paths[0] || '').toLowerCase();
        this.privateItems = paths.slice(1).map(function (urlPart) { return decodeURIComponent(urlPart); });
    };
    HashSeekerService.$inject = ['$location'];
    HashSeekerService = __decorate([
        Injectable('hashSeeker'),
        __param(0, Inject('$location')),
        __metadata("design:paramtypes", [Object])
    ], HashSeekerService);
    return HashSeekerService;
}());
export { HashSeekerService };
